module.exports = __webpack_public_path__ + "static/media/Netsecuris.543c852b.jpg";